import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import i18n from "../../i18n";
import DateFilter from "../ui/DateFilter";
import LoadingSpinner from "../Loading";

import InventoryWiseTable from "./Tables/InventoryWiseTable";
import GroupWiseTable from "./Tables/GroupWiseTable";
import CategoryWiseTable from "./Tables/CategoryWiseTable";

import InventorySaleSummaryTable from "../../app/inventory/InventorySaleSummary/InventorySaleSummaryTable";
import InventorySaleReport from "./InventorySaleReport";
import CategoryWiseReport from "./CategoryWiseReport";
import GroupSaleReport from "./GroupSaleReport";
import DiscountWiseReport from "./DiscountWiseReport";
import SalesmanReport from "../../app/settings/Salesman/SalesmanReport";
import OfferWiseReport from "./OfferWiseReport"

const CashierSalesReports = () => {
  const { t } = useTranslation();

  const [selected, setSelected] = useState("Inventory Wise");
  const [loading, setLoading] = useState(false);
  const contractType =
    useSelector((state) => state.login.contractType) || "Cashier_Ecom";

  const showCategorySalesReport = contractType !=="Cashier"

  const handleToggle = (_, value) => {
    if (value) {
      setSelected(value);
    }
  };

  return (
    <div className="flex min-h-screen w-full flex-col overflow-y-auto bg-[#F6F7F9] pb-6">
      <div>
        <Navbar heading={t("Cashier Sales Reports")} />
      </div>

      <div className="px-2 py-3 sm:px-3">
        {/* Toggle */}
        <div className="mb-4 mt-3 flex w-full items-center justify-center px-1 sm:mt-4 sm:px-4">
          <ToggleButtonGroup
            value={selected}
            exclusive
            onChange={handleToggle}
            sx={{
              borderRadius: "9999px", // Rounded pill shape
              p: "4px",
              backgroundColor: "#fff",
              border: "1px solid #cbd5e1", // Border around the whole group
              width: { xs: "100%", md: "auto" },
              overflowX: "auto",
              justifyContent: { xs: "flex-start", md: "center" },
              "& .MuiToggleButton-root": {
                border: "none", // Remove individual button borders
                borderRadius: "9999px",
                padding: { xs: "6px 14px", sm: "6px 24px" },
                color: "#6b7280",
                fontSize: "0.875rem",
                fontWeight: 500,
                textTransform: "none",
                marginRight: "1px", // Spacing between buttons
                whiteSpace: "nowrap",
                flexShrink: 0,
                "&:last-of-type": {
                  marginRight: 0, // No extra margin for last button
                },
              },
              "& .Mui-selected": {
                backgroundColor: "#38bdf8 !important",
                color: "#fff !important",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              },
            }}
          >
            <ToggleButton value="Inventory Wise">
              {t("Inventory Wise Sale")}
            </ToggleButton>
            <ToggleButton value="Group Wise">
              {t("Group Wise Sale")}
            </ToggleButton>
            {showCategorySalesReport && <ToggleButton value="Category Wise">
              {t("Category Wise Sale")}
            </ToggleButton>}
             <ToggleButton value="Discount Wise">
              {t("Discount Wise Sale")}
            </ToggleButton>
            <ToggleButton value = "Offer Wise">
               {t("Offer Wise Sale")}
            </ToggleButton>
               <ToggleButton value="Salesman Wise">
              {t("Salesman Wise Sale")}
            </ToggleButton>
          </ToggleButtonGroup>
        </div>

        {/* Loader */}
        {loading ? (
          <div className="flex justify-center py-10">
            <LoadingSpinner />
          </div>
        ) : (
          <>
            {selected === "Inventory Wise" && <InventorySaleReport />}

            {selected === "Group Wise" && <GroupSaleReport />}

            {selected === "Category Wise" &&  showCategorySalesReport && <CategoryWiseReport />}

            {selected === "Discount Wise" && <DiscountWiseReport />}
            {selected === "Offer Wise" && <OfferWiseReport />}
            {selected === "Salesman Wise" && <SalesmanReport />}
          </>
        )}
      </div>
    </div>
  );
};

export default CashierSalesReports;
